/** Profils de détection : ce qui fait perdre selon le mode de jeu. */
import type { CalibrationOptions } from './calibration';
import { DEFAULT_LAUGH_TIMING, type LaughDetectorOptions } from './laughDetector';
import { blinkScore, laughScore } from './scoring';
import type { Blendshapes } from './types';

export type ExpressionKind = 'laugh' | 'blink';

export interface DetectionProfile {
  readonly kind: ExpressionKind;
  readonly score: (bs: Blendshapes) => number;
  readonly calibration: Partial<CalibrationOptions>;
  readonly timing: Pick<LaughDetectorOptions, 'minDurationMs' | 'maxGapMs'>;
  /** Cadence d'analyse minimale (img/s) mesurée pendant la calibration ; 0 = aucune. */
  readonly minFps: number;
}

export const LAUGH_PROFILE: DetectionProfile = {
  kind: 'laugh',
  score: laughScore,
  calibration: {},
  timing: DEFAULT_LAUGH_TIMING,
  minFps: 0,
};

/**
 * Un clignement dure 100 à 400 ms : on exige ~2 images consécutives (≥ 40 ms)
 * pour écarter le bruit d'une image isolée, et au moins 20 img/s pour ne pas
 * rater de clignement (sinon l'appareil lent avantagerait son joueur).
 */
export const BLINK_PROFILE: DetectionProfile = {
  kind: 'blink',
  score: blinkScore,
  calibration: { minMargin: 0.3, maxBaseline: 0.4, maxThreshold: 0.85 },
  timing: { minDurationMs: 40, maxGapMs: 100 },
  minFps: 20,
};

export const profileFor = (kind: ExpressionKind): DetectionProfile =>
  kind === 'laugh' ? LAUGH_PROFILE : BLINK_PROFILE;
